import { useMemo, MouseEvent, ChangeEvent } from 'react';
import MuiPagination from '@mui/material/Pagination';
import type { TablePaginationProps } from '@mui/material/TablePagination';
import { GridPagination } from '@mui/x-data-grid-pro';
import i18n from '@shared/config/i18n';

const { t } = i18n;

type SlotPropsCustomPagination = {
  page: number;
  rowsPerPage: number;
  onPageChange: (event: ChangeEvent<unknown>, newPage: number) => void;
};

const Pagination = ({
  count,
  page,
  className,
  rowsPerPage,
  onPageChange,
}: TablePaginationProps) => {
  const handleChange = (event: ChangeEvent<unknown>, newPage: number) => {
    onPageChange(event as MouseEvent<HTMLButtonElement>, newPage - 1);
  };

  const countPage = useMemo(() => Math.ceil(count / rowsPerPage), [count, rowsPerPage]);

  return (
    <MuiPagination
      shape="rounded"
      count={countPage}
      page={page + 1}
      onChange={handleChange}
      className={className}
    />
  );
};

export const CustomPagination = (props: SlotPropsCustomPagination) => (
  <GridPagination
    ActionsComponent={Pagination}
    {...props}
    labelRowsPerPage={t('EntriesPerPage')}
    labelDisplayedRows={({ from, to, count }) =>
      `${from} - ${to} ${t('of')} ${count === -1 ? `${t('moreThan')} ${to}` : count}`
    }
  />
);
